import { AVAILABILITY, BLOCKAGE, EXTRA_TYPE_VARIANT } from "../../../Common/constants";

export default {
  locale: "en",
  name: "Extras",
  translation: { displayName: "Translations" },
  tabs: [
    {
      title: "Properties",
    },
    {
      title: "Images",
    },
    {
      title: "Single-use promocode",
      hideSubmitButton: true,
    },
  ],
  fields: {
    list: [
      {
        fieldName: "isActive",
        displayName: "Active",
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
        helpText: "Maximum characters: 8",
      },
      {
        fieldName: "name",
        displayName: "Name",
      },
      {
        fieldName: "type",
        displayName: "Type",
      },
      {
        fieldName: "rate",
        displayName: "Rate",
      },
      {
        fieldName: "validity",
        displayName: "Validity (dates)",
      },
      {
        fieldName: "availability",
        displayName: "Availability",
      },
      {
        fieldName: "blocking",
        displayName: "Block Validity",
      },
      {
        fieldName: "lockType",
        displayName: "Blocking behavior",
      },
      {
        fieldName: "confirmationEmailReceivers",
        displayName: "Email",
      },
      {
        fieldName: "minStay",
        displayName: "Min. Stay(d)",
      },
      {
        fieldName: "maxStay",
        displayName: "Max. Stay(d)",
      },
      {
        fieldName: "minNotice",
        displayName: "Min. Release(h)",
      },
      {
        fieldName: "maxNotice",
        displayName: "Max. Release(h)",
      },
      {
        fieldName: "promoCode",
        displayName: "Code",
      },
      {
        fieldName: "excludedRooms",
        displayName: "Excluded",
      },
    ],
    form: [
      {
        fieldName: "isActive",
        displayName: "Active",
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
      },
      {
        fieldName: "name",
        displayName: "Name",
      },
      {
        fieldName: "description",
        displayName: "Description",
      },
      {
        fieldName: "ratesSection",
        displayName: "Rates",
        widget: "section",
      },
      {
        fieldName: "rateType",
        displayName: "Rates",
      },
      {
        fieldName: "type",
        displayName: "Type",
      },
      {
        fieldName: "availabilityType",
        displayName: "Availability",
        widget: "selector",
        optionDisplay: {
          "": {
            label: "--",
          },
          [`AVAILABILITY_${AVAILABILITY.OWN}`]: {
            label: "Own",
          },
        },
        defaultValue: "",
      },
      {
        fieldName: "lockType",
        displayName: "Blocking and availability behavior",
        optionDisplay: {
          [EXTRA_TYPE_VARIANT.LOCK_TYPE_STAY]: {
            label: "Per stay",
          },
          [EXTRA_TYPE_VARIANT.LOCK_TYPE_DAY]: {
            label: "Per day",
          }
        },
      },
      {
        fieldName: "blockingType",
        displayName: "Blocking",
        optionDisplay: {
          "": {
            label: "--",
          },
          [BLOCKAGE.OWN]: {
            label: "Own",
          },
        },
      },
      {
        fieldName: "blockingValue",
        widget: "selector",
        transform: ({ entity, field }) => ({
          ...field,
          optionDisplay:
            entity &&
            entity.blockingValues &&
            entity.blockingValues.reduce((accum, it) => ({ ...accum, [it]: { label: it } }), {
              "": { label: "Choose inventory line" },
            }),
        }),
      },
      {
        fieldName: "appliesToGuests",
        displayName: "Applies to",
      },
      {
        fieldName: "maxBookableUnits",
        displayName: "Max. Bookable Units",
      },
      {
        fieldName: "codeSection",
        displayName: "Coupon / company code",
        widget: "section",
      },
      {
        fieldName: "promoCode",
        displayName: "Promo id",
      },
      {
        fieldName: "validitySection",
        displayName: "Validity",
      },
      {
        fieldName: "validFrom",
        displayName: "Start Date",
      },
      {
        fieldName: "validTo",
        displayName: "End Date",
      },
      {
        fieldName: "minStayType",
        displayName: "Min. Stay (days)",
      },
      {
        fieldName: "minStayValue",
      },
      {
        fieldName: "maxStayType",
        displayName: "Max. Stay (days)",
      },
      {
        fieldName: "maxStayValue",
      },
      {
        fieldName: "minNoticeType",
        displayName: "Min. Notice (hours)",
      },
      {
        fieldName: "minNoticeValue",
      },
      {
        fieldName: "maxNoticeType",
        displayName: "Max. Notice (hours)",
      },
      {
        fieldName: "maxNoticeValue",
      },
      {
        displayName: "Email list",
        fieldName: "emailSection",
      },
      {
        fieldName: "confirmationEmailReceivers",
        displayName: "Booking confirmation recipients",
      },
      {
        fieldName: "roomsWithExtrasSection",
        displayName: "Rooms with extra enabled",
        widget: "section",
      },
      {
        fieldName: "imageManagementSection",
        displayName: "Image management",
        widget: "section",
      },
      {
        fieldName: "infoMessage",
        value:
          "To activate single-use promocodes tab, you must save an extra first and access it again to edit.",
      },
    ],
  },
};
